<template>
    <div class="border border-gray-300 rounded-md shadow-md mx-1 mb-6">
        <slot/>
    </div>
</template>

<script>
export default {}
</script>
